export default __webpack_public_path__ + "static/push-8d013db1ef85775c9d99b4abe615fb6e.png";